// import View from "../../components/view/index";
import View from "../../components/viewer1/index";
import React, {useState, useMemo, useEffect, Profiler} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { getSlideInfo, getAnimalInfo } from "../../redux/reducers/animalResearchSlice"
import { render } from "../../debug/profiler";

const ViewContainer = ( props ) => {

  const usedispatch = useDispatch();
  // const [studyInfo, setStudyInfo] = useState(null);
  // const [slides, setSlides] = useState([]);
  // const [slidesLoading, setSlidesLoading] = useState(true);
  const slideid = props.match.params?.slideid;
  const animalid = props.match.params?.animalsid;

  // useEffect(() => {
  //   const studyParams = { id: props.match.params?.slideid};
  //   const slidesParams = { id: props.match.params?.animalsid};

  //   usedispatch(getAnimalInfo(slidesParams, (info) => {
  //     setSlidesLoading(false);
  //     setSlides(info ? info.Slides || []: []);
  //     usedispatch(getSlideInfo(studyParams, (info) => {
  //       setStudyInfo(info);
  //     }));
  //   }))
  // }, []);

  return (
    <div className="w-full h-full">
      <Profiler 
        id="test1" 
        onRender={render}>
        <View slideid={slideid} animalid={animalid}></View>
      </Profiler>
    </div>
  )
};

export default ViewContainer